import { createContext } from 'react';
import type { AgentInfo } from '@/api/types';

export interface SignedIn {
  status: 'signed-in';
  key: string;
  agent: AgentInfo;
}

export interface SignedOut {
  status: 'signed-out';
}

// A key the tab remembered, being verified before anything renders behind it.
export interface Restoring {
  status: 'restoring';
  key: string;
}

export type Session = SignedIn | SignedOut | Restoring;

export interface AgentContextValue {
  session: Session;
  signIn(key: string): Promise<AgentInfo>;
  signOut(): void;
}

export const AgentContext = createContext<AgentContextValue | null>(null);
